export default "__VITE_ASSET__yQ3RyQku__"